<template>
  <div class="scroll_load">
    <div class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
      <slot></slot>
    </div>
    <p class="more_box" v-if="loading">加载中...</p>
    <p class="more_box" v-if="noMore && !noText">没有更多了</p>
  </div>
</template>

<script>
export default {
  name: 'scroll_load',
  data() {
    return {
      noMore: false,
      loading: false
    }
  },
  props: {
    noText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disabled() {
      return this.loading || this.noMore
    }
  },
  mounted() {
    this.$EventBus.$on('scrollLoading', has => (this.loading = has))
    this.$EventBus.$on('scrollNoMore', has => (this.noMore = has))
  },
  beforeDestroy() {
    this.$EventBus.$off('scrollLoading','scrollNoMore')
  },
  methods: {
    load() {
      this.loading = true
      this.$EventBus.$emit('ScrollCallback')
    }
  }
}
</script>

<style lang='scss' scoped>
.scroll_load {
  width: 100%;
  height: 100%;
  overflow: auto;
  font-size: 0.8rem;
  .more_box {
    height: 1.6rem;
    line-height: 1.6rem;
    font-size: 0.4rem;
    text-align: center;
  }
}
</style>